import { z } from 'zod';
import { interviewSchema } from './interview/InterviewFormValues';
import { studentDetailsSchema } from './studentDetails/StudentDetailsFormValues';
import { familySchema } from './family/FamilyFormValues';
import { biographySchema } from './biography/BiographyFormValues';
import { housingSchema } from './housing/HousingFormValues';
import { dearFamilySchema } from './dearFamily/DearFamilyFormValues';
import { photoAlbumSchema } from './photoAlbum/PhotoAlbumFormValues';
import { documentsSchema } from './documents/DocumentsFormValues';
import { agreementsSchema } from './agreements/AgreementsFormValues';
import { vaccinationsSchema } from './vaccinations/VaccinationsFormValues';
import { schoolAndLanguagesSchema } from './schoolAndLanguages/SchoolAndLanguagesFormValues';

// This schema validates every required fields and data formats
export const schema = z.object({
  interview: interviewSchema.required,
  studentDetails: studentDetailsSchema.required,
  family: familySchema.required,
  biography: biographySchema.required,
  schoolAndLanguages: schoolAndLanguagesSchema.required,
  housing: housingSchema.required,
  dearFamily: dearFamilySchema.required,
  photoAlbum: photoAlbumSchema.required,
  documents: documentsSchema.required,
  agreements: agreementsSchema.required,
  vaccinations: vaccinationsSchema.required,
});

// This schema skips "required" validation errors and only checks format validation errors
// e.g. the format of the emails, the format of URLs, etc.
export const optionalSchema = z.object({
  interview: interviewSchema.optional,
  studentDetails: studentDetailsSchema.optional,
  family: familySchema.optional,
});
